export interface Locale {
  readonly locale: string;
  readonly wpcLocale: string;
  readonly wlcLocale: string;
  readonly storeURL: string;
  readonly localeName: string;
  readonly region: string;
  readonly cssClassName: string | null;
  readonly wpcSupported: boolean;
  readonly showInShortList: boolean;
  readonly store: string;
  readonly countryName: string;
}

export const DIGITAL_STORE: Locale = {
  locale: 'en_XS',
  wpcLocale: 'en_US',
  wlcLocale: 'en-US',
  storeURL: '/en-US/digital',
  localeName: 'Other Countries',
  region: 'Other',
  cssClassName: null,
  wpcSupported: true,
  showInShortList: true,
  store: 'digital',
  countryName: 'All Other Countries'
};

export const PREFERRED_DEFAULT_STORE = DIGITAL_STORE;
